import React from 'react';
import { SectionLayout } from '@/components/shared/section-layout';
import { BidUploadPage } from './components/bid-upload-page';

// Main bids page with upload, management, and comparison functionality
export function BidsPage() {
  return (
    <SectionLayout title="Bids">
      <BidUploadPage />
    </SectionLayout>
  );
} 